import Cookies from "js-cookie";
import store from '../store.js';
import PAGES from "../pages.js";
import MODULE from "./module.js";




var AUTH = {
	

	isGuest() {
		const _this = this;

		let userInfo = _this.getUserInfo();
		if (userInfo == undefined || userInfo == null) {
			return true;
		}

		return false;
	},
	getAccessToken() {
		let accessToken = localStorage.getItem("accessToken");
		if (accessToken != null && accessToken != undefined) {
			return accessToken;
		}

		return "";
	},
	createUserInfo(data) {
		
		let userInfo = {
			SOLUTION_ID: data.SOLUTION_ID,
			COMPANY_KEY: data.COMPANY_KEY,
			USER_KEY: data.USER_KEY,
			USER_ID: data.USER_ID,
			USER_NAME: data.USER_NAME,
			USER_TYPE: data.USER_TYPE,
			MONTH_POINT: data.MONTH_POINT,
			ACC_POINT: data.ACC_POINT,
			USER_CODE: data.USER_CODE,
			roleArray: data.roleArray,
			allowMenuList: data.allowMenuList,


			accessToken: data.accessToken
		};

		let showMenuArray = userInfo.allowMenuList.filter(item => {
			return item.menuType != "INVISIBLE_MENU";
		});

		if (showMenuArray.length > 0) {
			let firstTopMenu = showMenuArray[0];
			firstTopMenu.active = true;
		}

		store.commit("userInfo", userInfo);

		return userInfo;
	},
	getUserInfo() {
		let userInfo = store.getters.userInfo;
		return userInfo;
	},
	getUserCode() {
		let userInfo = store.getters.userInfo;
		return userInfo;
	},
	removeUserInfo() {
		store.commit("userInfo", null);
	},
	getUserMainPage() {
		let userInfo = this.getUserInfo();
		if (userInfo == null) {
			return PAGES.LOGIN_PAGE;
		}

		const allowMenuList = userInfo.allowMenuList;
		try {
			let sMenu = allowMenuList[0].childList[0].childList[0];
			return sMenu.url;
		} catch (e) {
			return PAGES.LOGIN_PAGE;
		}
	},
	setAccessToken(accessToken) {
		localStorage.setItem("accessToken", accessToken);
	},
	removeAccessToken() {
		localStorage.removeItem("accessToken");
	},
	setUserInfo(userInfo) {
		store.commit("userInfo", userInfo);
	},
	getUserInfoFromToken(accessToken) {
		const payload = accessToken.split(".")[1];
		return JSON.parse(atob(payload));
	},
	getExpireDate() {
		const _this = this;
		const accessToken = _this.getAccessToken();

		if (MODULE.Util.isNotEmpty(accessToken)) {			
		
			try {
				const jsonObject = JSON.parse(atob(accessToken.split('.')[1]));
				const expDate = moment(jsonObject.ext);

				return expDate;
			} catch (e) {
				return null;
			}
		}
	},
	savePlanStudyInfo(planStudyInfo) {

		let info = {
			PLANNER_KEY: planStudyInfo.plannerKey,
			TIMES_NO: planStudyInfo.timesNo,
			GRADE_ID: planStudyInfo.gradeId,
			SEMESTER_ID: planStudyInfo.semesterId,
			REVISE_ID: planStudyInfo.reviseId,
			GROUP_KEY: planStudyInfo.groupKey,
			STUDY_STEP: planStudyInfo.studyStep,
			LOGIN_FLG : true
		}
		var jsonStr = MODULE.Util.ObjectToJsonStr(info);			
		localStorage.setItem("planStudyInfo", jsonStr);
	},
	localGetPlanStudyInfo() {
		let planStudyInfo = localStorage.getItem("planStudyInfo");
		
		if (planStudyInfo != null && planStudyInfo != undefined) {
			var info = MODULE.Util.JsonStrToObject(planStudyInfo);
			return info;
		}

		return "";
	}

};

export default AUTH;